import React, { useState, useEffect } from 'react'
import { useLocation, Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import BlockManager from './BlockManager'
import MobileSidebar from './MobileSidebar'
import Header from './Header'
import PageBuilderHeader from './PageBuilderHeader'
import usePageBuilderStore from '../stores/pageBuilderStore'
import { useAuthStore } from '../stores/authStore'
import { api } from '../services/api'

function PageBuilderSidebar({ pageId }) {
  const viewMode = usePageBuilderStore((state) => state.viewMode)
  return <BlockManager pageId={pageId} viewMode={viewMode} />
}

function PostBuilderSidebar({ postId }) {
  const viewMode = usePageBuilderStore((state) => state.viewMode)
  return <BlockManager postId={postId} viewMode={viewMode} />
}

export default function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const location = useLocation()
  const content = children || <Outlet />
  const { user, setUser } = useAuthStore()

  useEffect(() => {
    const loadUser = async () => {
      if (!user) {
        try {
          const response = await api.get('/auth/me')
          if (response.data.success) {
            setUser(response.data.data)
          }
        } catch (error) {}
      }
    }
    loadUser()
  }, [user, setUser])

  const isPageBuilder =
    location.pathname.startsWith('/pages/') &&
    location.pathname.includes('/builder')
  const isPostBuilder =
    location.pathname.startsWith('/posts/') &&
    !location.pathname.endsWith('/posts')

  const pageId = isPageBuilder ? location.pathname.split('/')[2] : null
  const postId = isPostBuilder ? location.pathname.split('/')[2] : null

  if (isPageBuilder) {
    return (
      <div className="h-screen flex flex-col bg-gray-50">
        <MobileSidebar
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          isPageBuilder={isPageBuilder}
          pageId={pageId}
        />

        <div className="hidden lg:fixed lg:inset-y-0 lg:flex lg:w-64 lg:flex-col">
          <Sidebar>
            <PageBuilderSidebar pageId={pageId} />
          </Sidebar>
        </div>

        <div className="lg:pl-64 flex-1 flex flex-col overflow-hidden">
          <PageBuilderHeader
            onMenuClick={() => setSidebarOpen(true)}
            pageId={pageId}
          />
          <div className="flex-1 overflow-hidden">{content}</div>
        </div>
      </div>
    )
  }

  if (isPostBuilder) {
    return (
      <div className="h-screen flex flex-col bg-gray-50">
        <MobileSidebar
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          isPageBuilder={isPostBuilder}
          pageId={postId}
        />

        <div className="hidden lg:fixed lg:inset-y-0 lg:flex lg:w-64 lg:flex-col">
          <Sidebar>
            <PostBuilderSidebar postId={postId} />
          </Sidebar>
        </div>

        <div className="lg:pl-64 flex-1 flex flex-col overflow-hidden">
          <PageBuilderHeader
            onMenuClick={() => setSidebarOpen(true)}
            pageId={postId}
          />
          <div className="flex-1 overflow-hidden">{content}</div>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <MobileSidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        isPageBuilder={isPageBuilder}
        pageId={pageId}
      />

      <div className="hidden lg:fixed lg:inset-y-0 lg:flex lg:w-64 lg:flex-col">
        <Sidebar />
      </div>

      <div className="lg:pl-64">
        <Header onMenuClick={() => setSidebarOpen(true)} />

        <main className="py-6">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            {content}
          </div>
        </main>
      </div>
    </div>
  )
}
